/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import Buttons from '../buttons/buttons'
import './alert.css'

const Alert = ({
  alerttextclass,
  btn1className,
  btn1iconclassNmae,
  btn2classNmae,
  btn2iconclassNmae,
  cancel,
  className,
  handleRouteNo,
  handleRouteYes,
  icon,
  message,
  onClick,
  setShowAlert,
  title,
  titleicon,
  yes
}: any) => {
  const [opacity, setOpacity] = useState('opacity-0')

  useEffect(() => {
    setOpacity('opacity-100')
  }, [])

  const handleCancel = () => {
    setOpacity('opacity-0')
    if (handleRouteNo) handleRouteNo()
    setTimeout(() => {
     setShowAlert(false)
    }, 300)
  }

  const handleYes = () => {
    setOpacity('opacity-0')
    if (handleRouteYes) handleRouteYes()
    setTimeout(() => {
      setShowAlert(false)
    }, 300)
  }
  const handleRef = (ref: HTMLParagraphElement | null) => {
    const messageRef = ref
    if (messageRef) {
      messageRef.focus()
    }
  }
  return (
    <>
      <div className='alertoverly'></div>
      <div className={`alertsmain ${className} ${opacity}`}>
        {title && (
          <h2 className={alerttextclass}  tabIndex={0} >
            {titleicon && <span className={titleicon}></span>} {defaultToEmptyString(title)}
          </h2>
        )}
        <div className={alerttextclass} ref={handleRef} tabIndex={0}>
          {icon && <span className={icon}></span>} {defaultToEmptyString(message)}
        </div>
        <div className='d-flex gap-2 pt-2 justify-content-center'>
          <Buttons
            className={btn1className}
            icon={btn1iconclassNmae}
            label={yes}
            onClick={onClick ? () => onClick(yes) : handleYes}
            type='button'
          />
          <Buttons
            className={btn2classNmae}
            icon={btn2iconclassNmae}
            label={cancel}
            onClick={onClick ? () => onClick(cancel): handleCancel}
            type='button'
          />
        </div>
      </div>
    </>
  )
}
export default Alert
